import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import {
  _MlsDisclaimer,
  _Disclaimer,
} from './styles'

const MlsDisclaimer = ({ noBox, isKWFeed, isPillar9 }) => (
  <_MlsDisclaimer
    withBg={!noBox}
  >
    {
      isKWFeed ?
        <_Disclaimer>
          {`© ${(new Date()).getFullYear()} Information Technology Systems Ontario, Inc.`}
          <br />
          {
            'The information provided herein must only be used by consumers ' +
            'that have a bona fide interest in the purchase, sale, or lease of real estate ' +
            'and may not be used for any commercial purpose or any other purpose. ' +
            'Information deemed reliable but not guaranteed.'
          }
        </_Disclaimer>
        :
        isPillar9 ?
          <_Disclaimer>
            {
              'Data is supplied by Pillar 9\u2122 MLS\u00AE System. Pillar 9\u2122 is the owner of the copyright in its ' +
              'MLS\u00AE System. Data is deemed reliable but is not guaranteed accurate by Pillar 9\u2122. The trademarks ' +
              'MLS\u00AE, Multiple Listing Service\u00AE and the associated logos are owned by The Canadian Real ' +
              'Estate Association (CREA) and identify the quality of services provided by real estate professionals who ' +
              'are members of CREA. Used under license.'
            }
          </_Disclaimer>
          :
          <Fragment>
            <img
              src="/static/images/mls-reciprocity.png"
              alt="mls reciprocity"
            />
            <_Disclaimer>
              {
                'Disclaimer: This representation is based in whole or in part on data generated by the ' +
                'Chilliwack & District Real Estate Board, Fraser Valley Real Estate Board or ' +
                'Greater Vancouver REALTORS\u00AE which assumes no responsibility for its accuracy.' +
                ' MLS\u00AE, REALTOR\u00AE and the associated logos are trademarks of The Canadian Real Estate Association.'
              }
            </_Disclaimer>
          </Fragment>
    }
  </_MlsDisclaimer>
)


MlsDisclaimer.propTypes = {
  listing: PropTypes.shape({}),
  noBox: PropTypes.bool,
  isKWFeed: PropTypes.bool,
  isPillar9: PropTypes.bool,
}

export default MlsDisclaimer
